import { RouteObject } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import { OrganisationDetailsPage, OrganisationsPage } from '~features/organisations';
import ScheduledActionDetailPage from '~features/scheduledActions/pages/scheduledActionDetailPage';

import PreserveSearchNavigate from './components/preserveSearchNavigate';

const OrganisationsRoutes = (): RouteObject[] => {
	return [
		{
			path: pagePathSegments.Organisations,
			children: [
				{
					index: true,
					element: <OrganisationsPage />,
				},
				{
					path: ':id',
					children: [
						{
							index: true,
							element: <PreserveSearchNavigate to={pagePathSegments.General} />,
						},
						{
							path: pagePathSegments.General,
							element: <OrganisationDetailsPage tab='general' />,
						},
						{
							path: pagePathSegments.Users,
							element: <OrganisationDetailsPage tab='users' />,
						},
						{
							path: pagePathSegments.ResourceGroups,
							element: <OrganisationDetailsPage tab='resource-groups' />,
						},
						{
							path: pagePathSegments.Devices,
							element: <OrganisationDetailsPage tab='devices' />,
						},
						{
							path: pagePathSegments.Keys,
							element: <OrganisationDetailsPage tab='keys' />,
						},
						{
							path: pagePathSegments.ScheduledActions,
							children: [
								{
									index: true,
									element: <OrganisationDetailsPage tab='scheduled-actions' />,
								},
								{
									path: ':scheduledActionId',
									element: <ScheduledActionDetailPage />,
								},
							],
						},
					],
				},
			],
		},
	];
};

export default OrganisationsRoutes;
